import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Background, Container, Contents, Title } from '../Common/Common.style';
import {
  ItemWrapper,
  ItemContainer,
  ItemContainerLeft,
  ItemContainerRight,
  ItemContainerFull,
  Item,
  ItemTitle,
  ItemStatusTitle,
  ItemStatusContents,
  ItemImage,
  ItemArrow,
  PictureWrapper,
  Picture,
  Spacer,
  Hr,
  ItemNavigation,
  ItemNavigationTitle,
  ItemNavigationList,
  ItemNavigationListItem,
  ItemNavigationButton,
} from './TopPage.style';
import Placeholder from '../../../../components/Placeholder';
import { TABLET_P } from '../../../../constants';
import updateDiagnosisResult from '../../../../redux/actions/diagnosisResult';
import { CATEGORY_HAIRCARE, CATEGORY_SCALPCARE, CATEGORY_HAIR_SCALP_CARE } from '../CareMenuImage/CareMenuImageConst';

class TopPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUsedDiagnosis: true,
    };
  }

  componentWillMount() {
    if (localStorage.getItem('useDiagnosis') === 'yes') {
      this.setState({ isUsedDiagnosis: true });
    } else {
      this.setState({ isUsedDiagnosis: false });
    }
    // console.log('@ TopPage', this.props);
  }

  render() {
    const {
      copy,
      stylistDiagnosis,
      changeCurrentScene,
      diagnosisResult,
      sublimicDiagnosisResult,
      updateDiagnosisResult,
    } = this.props;
    const { scalpDiagnosis } = stylistDiagnosis;
    const sublimicDiagnosisResultsCopy = copy.sublimicDiagnosisResults;
    const { isUsedDiagnosis } = this.state;

    const getDamageLevelClass = () => {
      if (diagnosisResult && diagnosisResult.diagnosisResults && diagnosisResult.diagnosisResults.damageLevel) {
        return `level${diagnosisResult.diagnosisResults.damageLevel}`;
      }
      return 'level0';
    };

    const getTextByMarkDown = md =>
      md.split('__').map((item, index) => {
        if (index % 2) {
          return <strong key={index}>{item}</strong>;
        }
        return item;
      });

    return (
      <Background>
        <Container>
          <Title>
            {(sublimicDiagnosisResultsCopy &&
              sublimicDiagnosisResultsCopy.summary &&
              sublimicDiagnosisResultsCopy.summary.title) || <Placeholder w="300px" h="45px" />}
          </Title>
          <Hr />
          {/* {!isUsedDiagnosis ? <Spacer /> : null} */}
          <Contents>
            <ItemWrapper>
              <ItemContainer>
                <ItemContainerLeft>
                  <Item>
                    <ItemTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.hairTitle) || <Placeholder w="266px" h="36px" />}
                    </ItemTitle>
                    <ItemStatusTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.currentStatusTitle &&
                        getTextByMarkDown(sublimicDiagnosisResultsCopy.summary.currentStatusTitle)) || (
                        <Placeholder w="266px" h="21px" />
                      )}
                    </ItemStatusTitle>
                    {isUsedDiagnosis ? (
                      <React.Fragment>
                        <ItemStatusContents className="withDamageIndicator">
                          {(diagnosisResult &&
                            diagnosisResult.diagnosisResults &&
                            diagnosisResult.diagnosisResults.hairCurrentStatus &&
                            diagnosisResult.diagnosisResults.hairCurrentStatus.description) || (
                            <Placeholder w="266px" h="30px" />
                          )}
                        </ItemStatusContents>
                        <ItemImage>
                          <div className={`chart ${getDamageLevelClass()}`}>
                            <div className="text">
                              {(sublimicDiagnosisResultsCopy &&
                                sublimicDiagnosisResultsCopy.summary &&
                                sublimicDiagnosisResultsCopy.summary.damageLevelLabel) || (
                                <Placeholder w="150px" h="18px" />
                              )}
                            </div>
                            <div className="number">
                              {(diagnosisResult &&
                                diagnosisResult.diagnosisResults &&
                                diagnosisResult.diagnosisResults.damageLevel) || (
                                <Placeholder w="100px" h="40px" m="14px 0 0 0" />
                              )}
                            </div>
                            <div className="slice">
                              <div className="bar" />
                            </div>
                            <div className="slice2">
                              <div className="bar2" />
                            </div>
                          </div>
                        </ItemImage>
                      </React.Fragment>
                    ) : null}
                    {isUsedDiagnosis && <ItemArrow />}
                    <ItemStatusTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.necessaryCareTitle) || <Placeholder w="266px" h="21px" />}
                    </ItemStatusTitle>
                    <ItemStatusContents className="withPicture">
                      {(diagnosisResult &&
                        diagnosisResult.diagnosisResults &&
                        diagnosisResult.diagnosisResults.hairNecessaryCare &&
                        diagnosisResult.diagnosisResults.hairNecessaryCare.description &&
                        getTextByMarkDown(diagnosisResult.diagnosisResults.hairNecessaryCare.description)) || (
                        <Placeholder w="266px" h="30px" />
                      )}
                    </ItemStatusContents>
                  </Item>
                </ItemContainerLeft>
                <ItemContainerRight>
                  <Item>
                    <ItemTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.scalpTitle) || <Placeholder w="266px" h="36px" />}
                    </ItemTitle>
                    <ItemStatusTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.currentStatusTitle &&
                        getTextByMarkDown(sublimicDiagnosisResultsCopy.summary.currentStatusTitle)) || (
                        <Placeholder w="266px" h="21px" />
                      )}
                    </ItemStatusTitle>
                    {isUsedDiagnosis ? (
                      <React.Fragment>
                        <ItemStatusContents>
                          {(diagnosisResult &&
                            diagnosisResult.diagnosisResults &&
                            diagnosisResult.diagnosisResults.scalpCurrentStatus &&
                            diagnosisResult.diagnosisResults.scalpCurrentStatus.description) || (
                            <Placeholder w="266px" h="30px" />
                          )}
                        </ItemStatusContents>
                        <ItemStatusTitle>
                          {(sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.summary &&
                            sublimicDiagnosisResultsCopy.summary.idealstatus) || <Placeholder w="266px" h="21px" />}
                        </ItemStatusTitle>
                        <PictureWrapper>
                          {(!!scalpDiagnosis &&
                            scalpDiagnosis.stylistDiagnosis.idealImage.file.url && (
                              <Picture src={scalpDiagnosis.stylistDiagnosis.idealImage.file.url} alt="" />
                            )) || (
                            <Placeholder
                              w={window.innerWidth > TABLET_P ? '180px' : '190px'}
                              h={window.innerWidth > TABLET_P ? '135px' : '140px'}
                            />
                          )}
                        </PictureWrapper>
                        <ItemStatusTitle>
                          {(sublimicDiagnosisResultsCopy &&
                            sublimicDiagnosisResultsCopy.summary &&
                            sublimicDiagnosisResultsCopy.summary.densitydiameter) || <Placeholder w="266px" h="21px" />}
                        </ItemStatusTitle>
                        <ItemStatusContents>
                          {(diagnosisResult &&
                            diagnosisResult.diagnosisResults &&
                            diagnosisResult.diagnosisResults.scalpType &&
                            diagnosisResult.diagnosisResults.scalpType.description &&
                            getTextByMarkDown(diagnosisResult.diagnosisResults.scalpType.description)) || (
                            <Placeholder w="266px" h="30px" />
                          )}
                        </ItemStatusContents>
                      </React.Fragment>
                    ) : null}
                    {isUsedDiagnosis && <ItemArrow />}
                    <ItemStatusTitle>
                      {(sublimicDiagnosisResultsCopy &&
                        sublimicDiagnosisResultsCopy.summary &&
                        sublimicDiagnosisResultsCopy.summary.necessaryCareTitle) || <Placeholder w="100%" h="21px" />}
                    </ItemStatusTitle>
                    <ItemStatusContents>
                      {(diagnosisResult &&
                        diagnosisResult.diagnosisResults &&
                        diagnosisResult.diagnosisResults.scalpNecessaryCare &&
                        diagnosisResult.diagnosisResults.scalpNecessaryCare.description &&
                        getTextByMarkDown(diagnosisResult.diagnosisResults.scalpNecessaryCare.description)) || (
                        <Placeholder w="100%" h="30px" />
                      )}
                    </ItemStatusContents>
                  </Item>
                </ItemContainerRight>
              </ItemContainer>
              <ItemContainer>
                <ItemContainerFull>
                  <ItemNavigation>
                    <ItemNavigationTitle>
                      {(sublimicDiagnosisResult && sublimicDiagnosisResult.careMenuTitle) || (
                        <Placeholder w="266px" h="30px" />
                      )}
                    </ItemNavigationTitle>
                    <ItemNavigationList>
                      <ItemNavigationListItem>
                        <ItemNavigationButton
                          onClick={e => {
                            e.preventDefault();
                            if (changeCurrentScene) {
                              changeCurrentScene('care');
                            }
                            updateDiagnosisResult({
                              selectedCareMenu: CATEGORY_HAIRCARE,
                            });
                          }}
                        >
                          {(sublimicDiagnosisResult &&
                            sublimicDiagnosisResult.careMenuItems[0] &&
                            sublimicDiagnosisResult.careMenuItems[0].image &&
                            sublimicDiagnosisResult.careMenuItems[0].image.file &&
                            sublimicDiagnosisResult.careMenuItems[0].image.file.url && (
                              <Picture src={sublimicDiagnosisResult.careMenuItems[0].image.file.url} alt="" />
                            )) || <Placeholder w="100%" h="auto" />}
                          {(sublimicDiagnosisResult && sublimicDiagnosisResult.careMenuItems[0].label) || (
                            <Placeholder w="100%" h="54px" />
                          )}
                        </ItemNavigationButton>
                      </ItemNavigationListItem>
                      <ItemNavigationListItem>
                        <ItemNavigationButton
                          onClick={e => {
                            e.preventDefault();
                            if (changeCurrentScene) {
                              changeCurrentScene('care');
                            }
                            updateDiagnosisResult({
                              selectedCareMenu: CATEGORY_SCALPCARE,
                            });
                          }}
                        >
                          {(sublimicDiagnosisResult &&
                            sublimicDiagnosisResult.careMenuItems[1] &&
                            sublimicDiagnosisResult.careMenuItems[1].image &&
                            sublimicDiagnosisResult.careMenuItems[1].image.file &&
                            sublimicDiagnosisResult.careMenuItems[1].image.file.url && (
                              <Picture src={sublimicDiagnosisResult.careMenuItems[1].image.file.url} alt="" />
                            )) || <Placeholder w="100%" h="auto" />}
                          {(sublimicDiagnosisResult && sublimicDiagnosisResult.careMenuItems[1].label) || (
                            <Placeholder w="100%" h="54px" />
                          )}
                        </ItemNavigationButton>
                      </ItemNavigationListItem>
                      <ItemNavigationListItem>
                        <ItemNavigationButton
                          onClick={e => {
                            e.preventDefault();
                            if (changeCurrentScene) {
                              changeCurrentScene('care');
                            }
                            updateDiagnosisResult({
                              selectedCareMenu: CATEGORY_HAIR_SCALP_CARE,
                            });
                          }}
                        >
                          {(sublimicDiagnosisResult &&
                            sublimicDiagnosisResult.careMenuItems[2] &&
                            sublimicDiagnosisResult.careMenuItems[2].image &&
                            sublimicDiagnosisResult.careMenuItems[2].image.file &&
                            sublimicDiagnosisResult.careMenuItems[2].image.file.url && (
                              <Picture src={sublimicDiagnosisResult.careMenuItems[2].image.file.url} alt="" />
                            )) || <Placeholder w="100%" h="auto" />}
                          {(sublimicDiagnosisResult && sublimicDiagnosisResult.careMenuItems[2].label) || (
                            <Placeholder w="100%" h="54px" />
                          )}
                        </ItemNavigationButton>
                      </ItemNavigationListItem>
                    </ItemNavigationList>
                  </ItemNavigation>
                </ItemContainerFull>
              </ItemContainer>
            </ItemWrapper>
          </Contents>
        </Container>
      </Background>
    );
  }
}

TopPage.defaultProps = {
  copy: {},
  stylistDiagnosis: {},
  changeCurrentScene: null,
};
TopPage.propTypes = {
  copy: PropTypes.shape({}),
  stylistDiagnosis: PropTypes.shape({}),
  changeCurrentScene: PropTypes.func,
  diagnosisResult: PropTypes.shape({}).isRequired,
  sublimicDiagnosisResult: PropTypes.shape({}).isRequired,
  updateDiagnosisResult: PropTypes.func.isRequired,
};
const mapState = state => ({
  copy: state.salonConsultaionSiteOptions.siteCopy,
  stylistDiagnosis: state.stylistDiagnosis,
  scalpCamera: state.scalpCamera,
  diagnosisResult: state.diagnosisResult,
  sublimicDiagnosisResult: state.sublimicDiagnosisResult,
  scalpCameraDiagnosis: state.scalpCameraDiagnosis,
});
const mapDispatch = dispatch => ({
  updateDiagnosisResult: data => dispatch(updateDiagnosisResult(data)),
});
export default connect(mapState, mapDispatch)(TopPage);



// WEBPACK FOOTER //
// ./src/pages/SalonConsultationPage/SublimicDiagnosisResultPage/TopPage/TopPage.js